import palette from "../palette";

export default {
    paper: {
        backgroundColor: palette.white, 
        borderRadius: '16px',           
    },

}